import React from 'react';
import { distanceInWordsToNow } from 'date-fns';

import ProgressBar from '../../../../../../common/components/ProgressBar';
import './MetricWithProgress.css';

export default ({ translate, metric, icon, locale, name, strokeColors, style, uom, upperBound, lowerBound, iconMainColor, steps, extra }) => {
  const valueLabel = () => (
    <span className="valueLabel">
      {!!(metric && metric.value) && (
        <span>
          {metric.value.toLocaleString()} {uom}
        </span>
      )}
      {!(metric && metric.value) && <span>{translate(`carView.healtStatus.unknown`)}</span>}
    </span>
  );

  const multiplier = 100 / (upperBound || 100);
  const percentage = (metric && metric.value ? metric.value - (lowerBound || 0) : 0) * multiplier;
  const _steps = steps.map(step => (step - (lowerBound || 0)) * multiplier);

  let index = _steps.length;
  let color = iconMainColor || 'black';
  for (let i = 0; i < _steps.length; i++) {
    if (percentage <= _steps[i] && index === _steps.length) {
      index = i;
    }
  }

  if (strokeColors.length > index) {
    color = strokeColors[index];
  }

  return (
    <div className="MetricWithProgress" style={{ ...style }}>
      <div className="progressContainer">
        <div className="descriptionWrapper">
          <div className="description">
            <span className="icon" style={{ color }}>
              {icon || 'icon'}
            </span>
            <span>{translate(`carView.healtStatus.${name}`)} </span>
            {valueLabel()}
          </div>
          {!!extra && <div className="descriptionExtra" style={{ color }}>{extra}</div>}
        </div>
        <div>
          <ProgressBar steps={_steps} percentage={percentage} strokeColors={strokeColors} />
        </div>
        {!!(metric && metric.updatedAt) && (
          <div className="updatedAt">
            {translate('common.updatedAt')} {distanceInWordsToNow(metric.updatedAt, { addSuffix: true, locale })}
          </div>
        )}
      </div>
    </div>
  );
};
